import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";

import {
  isAdminManager,
  isClientManager,
  isVendorManager,
  isProjectManager,
  isFinanceManager,
} from "../hooks/useUserSession";

import { Menu } from "antd";
import {
  TranslationOutlined,
  TeamOutlined,
  PicLeftOutlined,
  UnorderedListOutlined,
  FormOutlined,
  LineChartOutlined,
  AppstoreOutlined,
  DatabaseOutlined,
  DollarOutlined,
  DashboardOutlined,
} from "@ant-design/icons";

import { LAYOUT_ADMIN_FILE_MANAGER_BROWSE } from "../layouts/admin/navigation";

import {
  LAYOUT_MANAGER_HOME_DASHBOARD,
  LAYOUT_MANAGER_JOB_NEW,
  LAYOUT_MANAGER_JOB_LIST,
  LAYOUT_MANAGER_CLIENT_LIST,
  LAYOUT_MANAGER_PROJECT_LIST,
  LAYOUT_MANAGER_VENDOR_LIST,
  LAYOUT_MANAGER_QA_LIST,
  LAYOUT_MANAGER_QUOTE_LIST,
} from "../layouts/manager/navigation";

import { LAYOUT_REPORT_PANEL } from "../layouts/report/navigation";

import { LAYOUT_FINANCE_PANEL } from "../layouts/finance/navigation";

const { SubMenu } = Menu;

/*
const ManagerSidebar = (props) => {

}*/
/**
 *
 */
class Sidebar extends Component {
  render() {
    // let location = useLocation();
    const { location } = this.props;

    const { darkMenu } = this.props.theme;
    return (
      <Menu
        theme={darkMenu === "true" ? "dark" : "light"}
        mode="inline"
        selectedKeys={[location.pathname]}
        style={{ height: "100%", borderRight: 0 }}
      >
        <Menu.Item
          key={LAYOUT_MANAGER_HOME_DASHBOARD}
          icon={<AppstoreOutlined />}
        >
          <NavLink to={LAYOUT_MANAGER_HOME_DASHBOARD} activeClassName="active">
            Home
          </NavLink>
        </Menu.Item>

        {isProjectManager(this.props.roles) && (
          <SubMenu key="job" icon={<TranslationOutlined />} title="Jobs">
            <Menu.Item key={LAYOUT_MANAGER_JOB_NEW} icon={<FormOutlined />}>
              <NavLink to={LAYOUT_MANAGER_JOB_NEW} activeClassName="active">
                New Job
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={LAYOUT_MANAGER_JOB_LIST}
              icon={<UnorderedListOutlined />}
            >
              <NavLink to={LAYOUT_MANAGER_JOB_LIST} activeClassName="active">
                Jobs
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={LAYOUT_MANAGER_QUOTE_LIST}
              icon={<UnorderedListOutlined />}
            >
              <NavLink to={LAYOUT_MANAGER_QUOTE_LIST} activeClassName="active">
                Quotes
              </NavLink>
            </Menu.Item>
          </SubMenu>
        )}

        {(isClientManager(this.props.roles) ||
          isFinanceManager(this.props.roles)) && (
          <SubMenu key="client" icon={<PicLeftOutlined />} title="Clients">
            <Menu.Item
              key={LAYOUT_MANAGER_CLIENT_LIST}
              icon={<UnorderedListOutlined />}
            >
              <NavLink to={LAYOUT_MANAGER_CLIENT_LIST} activeClassName="active">
                Clients
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={LAYOUT_MANAGER_PROJECT_LIST}
              icon={<UnorderedListOutlined />}
            >
              <NavLink
                to={LAYOUT_MANAGER_PROJECT_LIST}
                activeClassName="active"
              >
                Projects
              </NavLink>
            </Menu.Item>
          </SubMenu>
        )}

        {(isVendorManager(this.props.roles) ||
          isFinanceManager(this.props.roles)) && (
          <Menu.Item key={LAYOUT_MANAGER_VENDOR_LIST} icon={<TeamOutlined />}>
            <NavLink to={LAYOUT_MANAGER_VENDOR_LIST} activeClassName="active">
              Vendor
            </NavLink>
          </Menu.Item>
        )}

        {isVendorManager(this.props.roles) && (
          <Menu.Item key={LAYOUT_MANAGER_QA_LIST} icon={<DashboardOutlined />}>
            <NavLink to={LAYOUT_MANAGER_QA_LIST} activeClassName="active">
              QA
            </NavLink>
          </Menu.Item>
        )}

        {isFinanceManager(this.props.roles) && (
          <Menu.Item key={LAYOUT_FINANCE_PANEL} icon={<DollarOutlined />}>
            <NavLink to={LAYOUT_FINANCE_PANEL} activeClassName="active">
              Finances
            </NavLink>
          </Menu.Item>
        )}

        <Menu.Item key={LAYOUT_REPORT_PANEL} icon={<LineChartOutlined />}>
          <NavLink to={LAYOUT_REPORT_PANEL} activeClassName="active">
            Reports
          </NavLink>
        </Menu.Item>

        {isAdminManager(this.props.roles) && (
          <Menu.Item
            key={LAYOUT_ADMIN_FILE_MANAGER_BROWSE}
            icon={<DatabaseOutlined />}
          >
            <NavLink
              to={LAYOUT_ADMIN_FILE_MANAGER_BROWSE}
              activeClassName="active"
            >
              Files
            </NavLink>
          </Menu.Item>
        )}
      </Menu>
    );
  }
}

export default withRouter(Sidebar);
